import React from "react";
import { useState } from "react";
import axios from "axios";
import { getRoot } from "./helpers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./InquiryForm.css";

const options = [
  { value: 0, label: "Input the minimum dimension I want" },
  { value: 1, label: "Input the maximum dimensions I can fit" },
  {
    value: 2,
    label:
      "Input my current EZ ICE Rink Size so I can use my rink with synthetic ice",
  },
  { value: 3, label: "Manually select how many panels I want" },
];

function InquiryForm(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [province, setProvince] = useState("");
  const [phone, setPhone] = useState("");
  const [contactMethod, setContactMethod] = useState("Email");
  const [size, setSize] = useState("");
  const [style, setStyle] = useState("");
  const [location, setLocation] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const rinkType = toTitleCase(props.rinkType.replace(/_/g, " "));

  async function handleSubmit(event) {
    event.preventDefault();

    if (!name || !email || !province || !phone) {
      toast.error("Please make sure all fields are completed.");
      return;
    }

    setSubmitted(false);

    const payload = {
      name,
      email,
      province,
      phone,
      contactMethod,
      size,
      style,
      location,
      rinkType,
    };
    try {
      const response = await axios.post(
        `${getRoot()}/api/shopify/submit_rink_form`,
        payload
      );
      if (response.status < 400) {
        toast.success("Message sent successfully!");
        setSubmitted(true);
      } else {
        toast.error(
          "Submission unsuccessful - Please make sure all fields are completed."
        );
      }
    } catch (error) {
      console.error(error);
      toast.error(
        "Submission unsuccessful - Please make sure all fields are completed."
      );
    }
  }

  return (
    <>
      <div className="flex flex-col py-8 bg-gray-100 justify-center items-center">
        <div className="flex flex-col bg-gray-100 px-8 mb-4 text-4xl font-bold text-center mx-4">
          Contact Us
        </div>

        <div className="flex bk7:flex-col bk7:justify-center border-4 border-black rounded-xl">
          <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-xl bk7:ml-0 bk7:mt-4">
            <h1 className="text-4xl bk5:text-xl font-bold text-center">
              {rinkType} Inquiry Form
            </h1>

            <div className="mt-4 bk5:text-sm">
              Want to talk to a Backyard Rink Expert? Set up a call{" "}
              <a href="https://calendly.com/d/2x2-msz-tqr/backyard-rink-expert-consult">
                here.
              </a>
            </div>

            <div className="flex flex-col pt-4">
              <div className="flex justify-center items-center">
                <form className="bg-gray-100 rounded-lg space-y-4">
                  <div className="relative">
                    <label
                      for="name"
                      className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="relative">
                    <label
                      for="email"
                      className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="relative">
                    <label
                      for="province"
                      className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2"
                    >
                      State/Province
                    </label>
                    <input
                      type="text"
                      id="province"
                      className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                      placeholder="State/Province"
                      onChange={(e) => setProvince(e.target.value)}
                    />
                  </div>
                  <div className="relative">
                    <label
                      for="phone"
                      className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2"
                    >
                      Phone Number
                    </label>
                    <input
                      type="text"
                      id="phone"
                      className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                      placeholder="Phone Number"
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                  <div className="relative">
                    <label
                      for="contactMethod"
                      className="block text-gray-700 absolute left-[9px] bottom-[24px] text-xs bg-gray-100 px-2"
                    >
                      Preferred Contact Method
                    </label>
                    <select
                      id="contactMethod"
                      className="w-full mt-1 p-2 bg-gray-100 border-gray-400 border-2 rounded-md cursor-pointer"
                      onChange={(e) => setContactMethod(e.target.value)}
                    >
                      <option>Email</option>
                      <option>Phone</option>
                    </select>
                  </div>
                  <div className="relative">
                    <label
                      for="size"
                      className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2"
                    >
                      Do you have a size in mind?
                    </label>
                    <input
                      type="text"
                      id="size"
                      className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                      placeholder="30' x 60'"
                      onChange={(e) => setSize(e.target.value)}
                    />
                  </div>
                  <div className="relative">
                    <label
                      for="style"
                      className="block text-gray-700 absolute left-[9px] bottom-[27px] text-xs bg-gray-100 px-2"
                    >
                      {rinkType === "Synthetic Ice Rink"
                        ? "What are you interested in (select one):"
                        : "What style of rink are you interested in?"}
                    </label>

                    {rinkType === "Synthetic Ice Rink" ? (
                      <select
                        id="interest"
                        className="w-full mt-1 p-2 bg-gray-100 border-gray-400 border-2 rounded-md cursor-pointer"
                        onChange={(e) => setStyle(e.target.value)}
                      >
                        <option>Synthetic Ice Floor Panels Only</option>
                        <option>EZ ICE Rink Boards for Synthetic Ice</option>
                        <option>Both Floor Panels and Rink Boards</option>
                      </select>
                    ) : (
                      <input
                        type="text"
                        id="style"
                        className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                        placeholder="Arena Height"
                        onChange={(e) => setStyle(e.target.value)}
                      />
                    )}
                  </div>
                  <div className="relative">
                    <label
                      for="location"
                      className="block text-gray-700 absolute left-[9px] bottom-[28px] text-xs bg-gray-100 px-2"
                    >
                      Where do you plan to set up your {rinkType}?
                    </label>
                    <input
                      type="text"
                      id="location"
                      className="w-full mt-1 p-2 bg-gray-100  border-solid border-2 border-gray-400 rounded-md pl-3"
                      placeholder="Garage"
                      onChange={(e) => setLocation(e.target.value)}
                    />
                  </div>

                  {submitted && (
                    <div className="text-ezice-blue-600">
                      Thank you! We will contact you as soon as possible.
                    </div>
                  )}
                  <button
                    type="submit"
                    className="w-28 bg-ezice-blue-600 text-white py-2 border-gray-300 font-bold rounded-md "
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {rinkType === "Synthetic Ice Rink" && (
          <div className="bg-gray-100 mt-4 p-4 rounded-xl font-bold mb-4 text-center mx-4 bk7:text-lg text-[23px] max-w-[1052px]">
            Freezing temps? Tool-free, easy to assemble (real) ice rinks are a
            great option in cold climates. Setup in 60-minutes or less. Just add
            water. Click
            <a
              className="mx-1"
              href="https://ezicerinks.com/pages/ez-ice-rink-builder"
              target="_blank"
            >
              HERE
            </a>
            to build your next ice rink.
          </div>
        )}
      </div>
    </>
  );
}

function toTitleCase(str) {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export default InquiryForm;
